/**
 * Promissory note (NoteReview): `extract` (CommercialPromissoryNote) + the
 * scan-quality layer. `terms_check` lives only on the Mongo row, so it isn't
 * available here (EXTRACT_VIEWER.md §6.1).
 */
const noteConfig = {
  id: "note",
  schemas: ["NoteReview", "NoteExtractor"],
  routes: ["note"],
  title: "Promissory note",
  sections: [
    {
      kind: "fields",
      id: "review",
      title: "Review",
      fields: [
        { path: "scan_quality", label: "Scan quality", format: "enum", hideWhenEmpty: true },
        { path: "illegible_fields", label: "Illegible fields", itemTone: "warn", hideWhenEmpty: true },
        { path: "expected_note_count_met", label: "Expected note count met", hideWhenEmpty: true },
      ],
    },
  ],
  rules: [
    {
      id: "note-count",
      tone: "warn",
      when: { path: "expected_note_count_met", op: "false" },
      title: "Expected number of notes not found",
      target: { sectionId: "review", path: "expected_note_count_met" },
    },
    {
      id: "note-illegible",
      tone: "warn",
      when: { path: "illegible_fields", op: "notEmpty" },
      title: "{count} {count|plural:field was,fields were} illegible",
      target: { sectionId: "review", path: "illegible_fields" },
    },
  ],
};

export default noteConfig;
